const e = "Xoá trường tìm kiếm", c = "Chọn tùy chọn", l = {
  clearSearch: e,
  selectPlaceholder: c,
  "Select.InputSearch.Value:placeholder": "Tìm kiếm",
  "Select.InputSearch.Value:aria-label": "Tìm kiếm"
};
export {
  e as clearSearch,
  l as default,
  c as selectPlaceholder
};
